import {Creature, WarriorClass} from "@/store/level/types";

export class ContentDto {
    id!: number;
    chestContentType!: ChestContentType;
    gems!: number;
    creature!: Creature;
    skillToAll!: number;
    skillToOne!: number;
    artifactAtlas!: string;
    artifactId!: string;
    artifactName!: string;
    artifactEffect!: string;
    force!: WarriorClass;
    count!: number;
    creatureIds!: number[];
}

export class WheelContentDto extends ContentDto {
    sectorNumber!: number;
    chosen!: boolean;
    redCrystals!: number;
    blueCrystals!: number;
    tickets!: number;
}

export enum ChestContentType {
    GEMS = 'GEMS',
    RED_CRYSTALS = 'RED_CRYSTALS',
    BLUE_CRYSTALS = 'BLUE_CRYSTALS',
    TICKETS = 'TICKETS',
    HERO = 'HERO',
    ATTACK_TO_ALL = 'ATTACK_TO_ALL',
    DEFENCE_TO_ALL = 'DEFENCE_TO_ALL',
    HEALTH_TO_ALL = 'HEALTH_TO_ALL',
    ARTIFACT = 'ARTIFACT',
    FORCE = 'FORCE',
    ATTACK_TO_ONE = 'ATTACK_TO_ONE',
    DEFENCE_TO_ONE = 'DEFENCE_TO_ONE',
    HEALTH_TO_ONE = 'HEALTH_TO_ONE',
    ELEPHANT = 'ELEPHANT',
    SNAKE = 'SNAKE',
    EAGLE = 'EAGLE',
    HEALTH_PERCENT_TO_ALL = 'HEALTH_PERCENT_TO_ALL',
    PORTAL = 'PORTAL',

    HEALTH_PERCENT_TO_ONE = 'HEALTH_PERCENT_TO_ONE',
    ATTACK_PERCENT_TO_ALL = 'ATTACK_PERCENT_TO_ALL',
    DEFENCE_PERCENT_TO_ALL = 'DEFENCE_PERCENT_TO_ALL',
    ATTACK_PERCENT_TO_ONE = 'ATTACK_PERCENT_TO_ONE',
    DEFENCE_PERCENT_TO_ONE = 'DEFENCE_PERCENT_TO_ONE',
    AMETIST = 'AMETIST',
    BOOSTER = 'BOOSTER',
    SLOT_UNLOCK = 'SLOT_UNLOCK',
    HERO_RANK = 'HERO_RANK'
}

// ARTIFACT = 'ARTIFACT',
//     FORCE = 'FORCE',
//     HERO = 'HERO',
//
//     RESOURCE_GEMS = 'RESOURCE_GEMS',
//     RESOURCE_CRYSTAL = 'RESOURCE_CRYSTAL',
//     RESOURCE_ELIXIR = 'RESOURCE_ELIXIR',
//
//     ATTACK_TO_ALL = 'ATTACK_TO_ALL',
//     DEFENCE_TO_ALL = 'DEFENCE_TO_ALL',
//     HEALTH_TO_ALL = 'HEALTH_TO_ALL',
//
//     ATTACK_TO_ONE = 'ATTACK_TO_ONE',
//     DEFENCE_TO_ONE = 'DEFENCE_TO_ONE',
//     HEALTH_TO_ONE = 'HEALTH_TO_ONE'
